import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ClerkService } from 'ngx-clerk-iliad';
import { map, take, catchError, of, Observable } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const clerkService = inject(ClerkService);

  // Return an Observable that checks authentication status
  return clerkService.user$.pipe(
    take(1),
    map(user => {
      const isAuthenticated = !!user;
      if (!isAuthenticated) {
        // If not authenticated, redirect to auth page immediately
        router.navigate(['/auth']);
        return false;
      }
      return true;
    }),
    catchError(() => {
      router.navigate(['/auth']);
      return of(false);
    })
  );
};
